import validator from 'validator';

export const validateEmail = (valueToBeValidated: string | boolean) => {
  if (typeof valueToBeValidated === 'boolean') {
    return false;
  }

  return validator.isEmail(valueToBeValidated);
};

export const validateName = (valueToBeValidated: string | boolean) => {
  if (typeof valueToBeValidated === 'boolean') {
    return false;
  }
  const regexp = /^[\p{General_Category=Letter} -]*$/gu;

  return regexp.test(valueToBeValidated);
};

export const validateLink = (link: string) =>
  validator.isURL(link, { protocols: ['https'] }) && link.startsWith('https://');

export * from './types';
